import { useState, useCallback } from "react";

import AddScreenForm from "../../components/adminDashboard/ui/screens/AddScreenForm";

import ScreenTable from "../../components/adminDashboard/ui/screens/ScreenTable";

export default function ScreenManagement() {
  const [activeTab, setActiveTab] = useState("add");

  const [editingScreen, setEditingScreen] = useState(null);

  const [refreshKey, setRefreshKey] = useState(0);

  const [showForm, setShowForm] = useState(true); // Force remount

  // EDIT

  const handleEdit = useCallback((screen) => {
    setEditingScreen(screen);

    setActiveTab("add");

    setShowForm(true);
  }, []);

  // AFTER SAVE / UPDATE

  const handleSuccess = useCallback(() => {
    setEditingScreen(null);

    setActiveTab("list");

    setRefreshKey((prev) => prev + 1);

    // Force form remount when going back to add

    setShowForm(false);

    setTimeout(() => setShowForm(true), 100);
  }, []);

  const handleAddClick = useCallback(() => {
    setActiveTab("add");

    setEditingScreen(null);

    setShowForm(true);
  }, []);

  return (
    <div className="ad-card ad-card-lg ad-animate" style={{ overflow: 'visible' }}>
      {/* Header */}
      <div className="ad-card-header">
        <h3 className="ad-card-title">Screen Management</h3>
        <div style={{ display: "flex", gap: "10px" }}>
          <button
            className={`ad-btn ${activeTab === "add" ? "ad-btn-blue" : ""}`}
            onClick={handleAddClick}
          >
            Add Screen
          </button>
          <button
            className={`ad-btn ${activeTab === "list" ? "ad-btn-blue" : ""}`}
            onClick={() => setActiveTab("list")}
          >
            Screen List
          </button>
        </div>
      </div>

      {/* Content */}
      <div className="ad-onboard-scroll">
        {activeTab === "add" && showForm && (
          <AddScreenForm
            key={editingScreen?.screenId || "new"} // Force remount when editing screen changes
            screenData={editingScreen}
            onSuccess={handleSuccess}
          />
        )}

        {activeTab === "list" && (
          <ScreenTable onEdit={handleEdit} refreshKey={refreshKey} />
        )}
      </div>
    </div>
  );
}
